"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var CfgCountryListCtl = /** @class */ (function (_super) {
    __extends(CfgCountryListCtl, _super);
    function CfgCountryListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.code; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_is_unknown = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_unknown; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_locales_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.locales_count; });
        _this.dk_phone_prefix_inner = UIUtils_1.UIUtils.IProp2Str(function (o) { o.phone_prefix_inner; });
        _this.dk_phone_prefix_outer = UIUtils_1.UIUtils.IProp2Str(function (o) { o.phone_prefix_outer; });
        _this.dk_css_classname = UIUtils_1.UIUtils.IProp2Str(function (o) { o.css_classname; });
        _this._errDialog = errDialog;
        return _this;
    }
    CfgCountryListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    CfgCountryListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    CfgCountryListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListCountryGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    code: resp.list[i].code,
                    is_deprecated: resp.list[i].is_deprecated,
                    is_unknown: resp.list[i].is_unknown,
                    title: resp.list[i].title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    locales_count: resp.list[i].locales_count,
                    phone_prefix_inner: resp.list[i].phone_prefix_inner,
                    phone_prefix_outer: resp.list[i].phone_prefix_outer,
                    css_classname: resp.list[i].css_classname
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgCountryListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddCountry.exec({
            data: {
                title: data.title,
                code: data.code,
                is_deprecated: data.is_deprecated,
                is_unknown: data.is_unknown,
                phone_prefix_inner: data.phone_prefix_inner,
                phone_prefix_outer: data.phone_prefix_outer,
                css_classname: data.css_classname
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                code: data.code,
                is_deprecated: data.is_deprecated,
                is_unknown: data.is_unknown,
                locales_count: 0,
                phone_prefix_inner: data.phone_prefix_inner,
                phone_prefix_outer: data.phone_prefix_outer,
                css_classname: data.css_classname
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgCountryListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditCountry.exec({
                data: {
                    app_country_id: data.key,
                    title: data.title,
                    code: data.code,
                    is_deprecated: data.is_deprecated,
                    is_unknown: data.is_unknown,
                    phone_prefix_inner: data.phone_prefix_inner,
                    phone_prefix_outer: data.phone_prefix_outer,
                    css_classname: data.css_classname
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.code = data.code;
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.is_unknown = data.is_unknown;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.phone_prefix_inner = data.phone_prefix_inner;
                _tmp.phone_prefix_outer = data.phone_prefix_outer;
                _tmp.css_classname = data.css_classname;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgCountryListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    CfgCountryListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteCountry.exec({ data: { app_country_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgCountryListCtl.prototype.SetIsDeprecated = function (key, IsDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetCountryIsDeprecated.exec({ data: { app_country_id: key, is_deprecated: IsDeprecated } }, function (resp) {
                _tmp.is_deprecated = IsDeprecated;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgCountryListCtl.prototype.SetAllIsDeprecated = function (IsDeprecated, onDone) {
        var _this = this;
        webAApi_1.DoSetAllCountryIsDeprecated.exec({ data: { is_deprecated: IsDeprecated } }, function (resp) {
            _this.LoadData(function () {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            });
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgCountryListCtl.prototype.SetIsUnknown = function (key, IsUnknown, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetCountryIsUnknown.exec({ data: { app_country_id: key, is_unknown: IsUnknown } }, function (resp) {
                _tmp.is_unknown = IsUnknown;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return CfgCountryListCtl;
}(BaseController_1.BaseController));
exports.CfgCountryListCtl = CfgCountryListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_country/ctl/CfgCountryListCtl.ts
// module id = 884
// module chunks = 0